const components = [
    {
        "label": "Observers",
        "widget": "choicesjs",
        "placeholder": "Select observers",
        "tooltip": "Select one or more observers for this task.",
        "tableView": false,
        "multiple": true,
        "dataSrc": "url",
        "data": {
          "url": "/user",
          "headers": [
            {
              "key": "",
              "value": ""
            }
          ]
        },
        "idPath": "uuid",
        "valueProperty": "uuid",
        "template": "<span>{{ item.name }}</span>",
        "validate": {
          "select": false
        },
        "key": "observers",
        "properties": {
          "absoluteUrl": "true",
          "data_type": "text"
        },
        "type": "select",
        "lazyLoad": false,
        "selectValues": "data",
        "disableLimit": false,
        "searchField": "name",
        "limit": 10,
        "noRefreshOnScroll": false,
        "input": true
      },
      {
        "label": "observersname",
        "redrawOn": "observers",
        "calculateValue": "for(let i=0; i< observers.length; i++)\n{\n  if(data.observers[i].name == undefined && data.userprofile[i]){\n  value = data.userprofile[i].name;\n  } \n  else {\n  value = data.observers[i].name;\n  }\n}\n",
        "key": "observersname",
        "type": "hidden",
        "input": true,
        "tableView": false
      }
];
export default components;
